const fn = {
  init: () => {

    const loadMore = document.querySelectorAll('.news-list-load-more')
    loadMore.forEach((el) => {
      el.addEventListener('click', function (e) {

        const els = document.querySelectorAll('.news-list-article.overflowed-article')
        els.forEach((el) => {
          el.classList.toggle('hidden')

          setTimeout(function() {
            el.classList.toggle('visible');
          }, 200);

        })

        e.target.innerHTML = e.target.innerHTML === 'Show All' ? 'Show Less' : 'Show All'

      })
    })

  },
}

export default {
  can: () => document.querySelector('#news-list-news') !== null,
  run: fn.init,
}
